import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  to?: string;
  linkLabel?: string;
  className?: string;
}

export function SectionHeading({ title, to, linkLabel = 'Ver tudo', className = 'mb-4' }: SectionHeadingProps) {
  return (
    <div className={`flex items-baseline justify-between gap-4 ${className}`}>
      <h2 className="text-xl md:text-2xl font-display font-semibold text-text-dark text-balance">{title}</h2>
      {to && (
        <Link
          to={to}
          className="text-sm font-semibold text-chocolate-dark hover:text-chocolate transition-colors whitespace-nowrap"
        >
          {linkLabel} →
        </Link>
      )}
    </div>
  );
}
